import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';
import { initializeForm } from '../../../utils/form';
import { validateNotEmpty } from '../../../utils/validators';

$(() => {
  const initializeHowFundsEarnedSection = (htmlElement) => {
    const element = $(htmlElement);

    const howFundsEarnedInput = element.find('input[name="how-funds-earned"]');
    const fundsEarnedYesButton = element.find('#how-funds-earned-yes-button');
    const fundsEarnedNoButton = element.find('#how-funds-earned-no-button');
    const howFundsEarnedTextareaSection = element.find(
      '#how-funds-earned-textarea-section'
    );
    const sourceOfIncomeTextarea = element.find(
      'textarea[name="source-of-income"]'
    );
    const isRequired = element.find('#is-mandatory').val() === 'True';

    const showHowEarnedFundsTextareaSection = () => {
      howFundsEarnedInput.val('no');
      fundsEarnedYesButton.removeClass('active');
      fundsEarnedNoButton.addClass('active');
      howFundsEarnedTextareaSection.removeClass('d-none');
      updateSectionValidationState();
    };

    const hideHowEarnedFundsTextareaSection = () => {
      howFundsEarnedInput.val('yes');
      sourceOfIncomeForm.restart();
      fundsEarnedYesButton.addClass('active');
      fundsEarnedNoButton.removeClass('active');
      howFundsEarnedTextareaSection.addClass('d-none');
      sourceOfIncomeTextarea.val('').trigger('change');
      updateSectionValidationState();
    };

    const updateSectionValidationState = () => {
      if (isRequired) {
        const howFundsEarnedInputValue = howFundsEarnedInput.val();
        let valid = true;

        if (howFundsEarnedInputValue === 'yes') {
          valid = true;
        } else if (howFundsEarnedInputValue === 'no') {
          valid = !!sourceOfIncomeTextarea.val();
        } else {
          valid = false;
        }

        const eventType = valid
          ? ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR
          : ADDITIONAL_DETAILS_EVENTS.ADD_ERROR;

        EVENT_BUS.dispatch(eventType, {
          error: ADDITIONAL_DETAILS_EVENTS.ERROR.SOURCE_OF_FUNDS,
        });
      }
    };

    const sourceOfIncomeForm = initializeForm(howFundsEarnedTextareaSection, {
      preventDefault: true,
      validate: (values) => {
        const errors = {
          ...validateNotEmpty(values, ['source-of-income']),
        };
        return errors;
      },
    });

    // set state if initial values provided in template
    const howFundsEarnedInputValue = howFundsEarnedInput.val();
    if (howFundsEarnedInputValue === 'no') {
      showHowEarnedFundsTextareaSection();
    } else if (howFundsEarnedInputValue === 'yes') {
      hideHowEarnedFundsTextareaSection();
    } else {
      updateSectionValidationState();
    }

    fundsEarnedYesButton.on('click', hideHowEarnedFundsTextareaSection);
    fundsEarnedNoButton.on('click', showHowEarnedFundsTextareaSection);
    sourceOfIncomeTextarea.on('input', updateSectionValidationState);
  };

  const sections = $('.how-funds-earned-section');
  sections.each((_, element) => initializeHowFundsEarnedSection(element));
});
